<template>
  <div class="flex">
    <button
      class="rounded-full border px-6 py-1 font-bold focus:ring focus:border-primary focus:outline-none mr-8"
      :class="
        showPending
          ? 'border-primary text-primary'
          : 'border-textPrimary  opacity-20'
      "
      @click="
      showSettled = false;
      showPending = true;
      "
    >Pending</button>
    <button
      class="rounded-full border px-6 py-1 font-bold focus:ring focus:border-primary focus:outline-none"
      :class="
        showSettled
          ? 'border-primary text-primary'
          : 'border-textPrimary  opacity-20'
      "
      @click="
      showSettled = true;
      showPending = false;
      "
    >Settled</button>
  </div>
  <div class="overflow-auto pr-2">
    <template v-if="showPending">
      <div v-if="transactions?.pendingTransactions?.unpaidTxnCount" class="grid">
        <div class="flex bg-gray-100 px-4 py-3 mt-4 justify-between items-center">
          <div class>
            <p class="text-xs">Total Transaction Amount</p>
            <p class="font-bold text-2xl">
              {{
                $filters.formatMoney(
                  transactions?.pendingTransactions?.outstandingAmount
                )
              }}
            </p>
          </div>
        </div>
        <p class="text-sm mt-4 flex items-center">
          <span
            class="font-bold bg-gray-100 rounded-full flex justify-center items-center w-10 h-10 mr-4"
          >{{ transactions?.pendingTransactions?.unpaidTxnCount }}</span>
          Transactions
        </p>
        <router-link
          :to="{ name: 'Supplier Pay Now', params: { ...transaction } }"
          class="grid gap-4 mt-4 bg-gray-100 pl-2 pr-16 py-4 rounded-md bg-details-arrow bg-no-repeat bg-details-arrow--modified"
          v-for="(transaction, index) in transactions?.pendingTransactions
          ?.unsettledTransactionList"
          :key="index"
        >
          <div class="flex justify-between gap-4 items-center">
            <p
              class="capitalize bg-white rounded-full w-12 h-12 flex items-center justify-center"
            >{{ transaction.marketplaceName?.trim().charAt(0) }}</p>
            <div class="flex-1">
              <p class="font-semibold">{{ transaction.marketplaceName }}</p>
              <p class="text-gray-500">Due date: {{ $filters.formatDate(transaction.txnDueDate) }}</p>
            </div>
            <p
              class="text-errorColor font-bold text-sm"
            >- {{ $filters.formatMoney(transaction.netPayableAmount) }}</p>
          </div>
        </router-link>
        <Observer @intersect="intersected" />

        <loader
          :loading="isLoading"
          v-if="isLoading"
          variant="primary"
          class="justify-self-center"
        />
      </div>
      <no-data-available v-else imageName="no-transactions.png" message="No transactions yet" />
    </template>
    <template v-if="showSettled">
      <div v-if="transactions?.settledTransactions?.availableSettledTxns" class="grid">
        <p class="text-sm mt-4 flex items-center">
          <span
            class="font-bold bg-gray-100 rounded-full flex justify-center items-center w-10 h-10 mr-4"
          >{{ transactions?.settledTransactions?.availableSettledTxns }}</span>
          Transactions
        </p>
        <div
          class="grid gap-4 mt-4"
          v-for="(transaction, index) in transactions?.settledTransactions
          ?.settledTransactionList"
          :key="index"
        >
          <router-link
            :to="{
              name: 'Supplier Transaction Details',
              params: { ...transaction },
            }"
            class="flex justify-between gap-4 items-center bg-details-arrow bg-details-arrow--modified bg-no-repeat bg-gray-100 pl-2 pr-16 py-4"
          >
            <p
              class="capitalize bg-gray-50 rounded-full w-12 h-12 flex items-center justify-center"
            >{{ transaction.marketplaceName?.trim().charAt(0) }}</p>
            <div class="flex-1">
              <p class="font-semibold">{{ transaction.marketplaceName }}</p>
              <p class="text-gray-500">{{ $filters.formatDate(transaction.txnDate) }}</p>
            </div>
            <p
              class="text-successColor font-bold text-sm"
            >+ {{ $filters.formatMoney(transaction.paidAmount) }}</p>
          </router-link>
        </div>
        <Observer @intersect="intersected" />
        <loader
          :loading="isLoading"
          v-if="isLoading"
          variant="primary"
          class="justify-self-center"
        />
      </div>
      <no-data-available v-else imageName="no-transactions.png" message="No transactions yet" />
    </template>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import NoDataAvailable from './NoDataAvailable.vue';
import Loader from './Loader.vue';
import Observer from './Observer.vue';

export default {
  name: 'SupplierTransactions',
  components: {
    NoDataAvailable,
    Loader,
    Observer,
  },
  computed: {
    ...mapGetters(['uuid']),
  },
  data() {
    return {
      showPending: true,
      showSettled: false,
      count: 10,
      pendingTransactionCount: undefined,
      settledTransactionCount: undefined,
      transactions: undefined,
      isLoading: false,
      start: 0,
      myRetailUrl: process.env.VUE_APP_MY_RETAIL_URL,
    };
  },
  mounted() {
    this.supplierTransactionDetails();
  },
  watch: {
    showPending() {
      this.start = 0;
      this.transactions = undefined;
      this.supplierTransactionDetails();
    },
  },
  methods: {
    intersected() {
      if (!this.isLoading && this.start) {
        if (
          (this.showPending &&
            this.start <
            this.transactions.pendingTransactions.unpaidTxnCount) ||
          (this.showSettled &&
            this.start <
            this.transactions.settledTransactions.availableSettledTxns)
        ) {
          this.supplierTransactionDetails();
        }
      }
    },
    supplierTransactionDetails() {
      this.isLoading = true;
      this.$store
        .dispatch('supplierTransactionDetails', {
          uuid: this.uuid,
          urlParams: {
            pageNo: this.start,
            pageSize: this.count,
            marketplaceId: this.$route.params.id,
          },
        })
        .then((response) => {
          if (this.start) {
            if (
              this.showPending &&
              this.start < this.transactions.pendingTransactions.unpaidTxnCount
            ) {
              this.transactions.pendingTransactions.unsettledTransactionList.push(
                ...response.pendingTransactions.unsettledTransactionList
              );
              this.start += 1;
            } else if (
              this.showSettled &&
              this.start <
              this.transactions.settledTransactions.availableSettledTxns
            ) {
              this.transactions.settledTransactions.settledTransactionList.push(
                ...response.settledTransactions.settledTransactionList
              );
              this.start += 1;
            }
          } else {
            this.transactions = response;
            this.start += 1;
          }
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
